import type { ComponentEventHandler } from '@archipro-design/aria';
import { useAppDisplayModeContext } from '@archipro-design/aria';
import { useStyles } from '@archipro-design/aria';
import * as S from './ClickAndCollect.styles';
import { useLoaderData } from '@remix-run/react';
import { Delivery, Icon, DeliverySelectIcon, Region } from './Delivery.styles';
import { useVariantShipping } from '../../hook/use-variant-shipping';
import { ChevronDown } from '@archipro-design/icons';
import { AngleDown } from '@archipro-design/icons';
import type { ProductPageLoaderData } from '~/routes/_app.product.$urlSegment';

interface ClickAndCollectData {
    Professional: {
        PickupLocations: {
            ID: number;
            Title: string;
            PickupEstimateText: string;
            RegionType: {
                ID: number;
                Title: string;
            };
            FormattedAddress: string;
        }[];
    };
}

interface Props {
    onLocationClick?: ComponentEventHandler<void>;
    isSample: boolean;
    hasLeadTime?: boolean;
}

const ClickAndCollect = ({
    onLocationClick,
    isSample,
    hasLeadTime = false,
}: Props) => {
    const { css } = useStyles();
    const { product } = useLoaderData<ProductPageLoaderData>();
    const { shipping } = useVariantShipping(isSample);
    const data = product as ClickAndCollectData;
    const canPickup = Boolean(data.Professional?.PickupLocations?.length);
    const pickupLocations = data.Professional?.PickupLocations ?? [];
    const { mobile } = useAppDisplayModeContext();

    const selectedLocation =
        shipping?.type === 'clickAndCollect' && shipping.ID
            ? pickupLocations.find((l) => l.ID === shipping.ID)
            : null;
    const label = 'Click & Collect from ';

    const pickupEstimate = selectedLocation?.PickupEstimateText
        ? `${selectedLocation.PickupEstimateText}${
              hasLeadTime ? ', after lead time' : ''
          }`
        : 'Click & Collect available';

    return canPickup ? (
        <>
            {selectedLocation && (
                <div className={css(Delivery)}>
                    {label}
                    <u className={css(Region)} onClick={onLocationClick}>
                        {selectedLocation.Title}
                        {selectedLocation.RegionType &&
                            `, ${selectedLocation.RegionType.Title}`}
                        {!mobile && (
                            <ChevronDown className={css(DeliverySelectIcon)} />
                        )}
                        {mobile && (
                            <span className={css(Icon)}>
                                <AngleDown />
                            </span>
                        )}
                    </u>
                </div>
            )}
            <div className={css(Delivery, S.ClickAndCollect)}>
                {pickupEstimate}
            </div>
        </>
    ) : null;
};

export default ClickAndCollect;
